import { render } from "./CreateChatMessage.vue?vue&type=template&id=2302cd91"
import script from "./CreateChatMessage.vue?vue&type=script&lang=js"
export * from "./CreateChatMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__